import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { QrCode, Download } from "lucide-react";
import { QRCodeSVG } from "qrcode.react";
import { Button } from "../components/ui/button";

const SITE_URL = window.location.origin + "/#carte";

export const QRCodeSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  const handleDownload = () => {
    const svg = document.getElementById("menu-qr-code");
    if (!svg) return;

    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement("canvas");
    canvas.width = 800;
    canvas.height = 800;
    const ctx = canvas.getContext("2d");

    // White background
    ctx.fillStyle = "#FDFBF7";
    ctx.fillRect(0, 0, 800, 800);

    const img = new Image();
    img.onload = () => {
      ctx.drawImage(img, 100, 100, 600, 600);

      // Add text
      ctx.fillStyle = "#2C2420";
      ctx.font = "italic 32px 'Georgia', serif";
      ctx.textAlign = "center";
      ctx.fillText("L'Ancienne Poste", 400, 60);

      ctx.fillStyle = "#8C847F";
      ctx.font = "14px 'Arial', sans-serif";
      ctx.fillText("Scannez pour voir notre carte", 400, 770);

      const link = document.createElement("a");
      link.download = "qrcode-ancienne-poste.png";
      link.href = canvas.toDataURL("image/png");
      link.click();
    };
    img.src = "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(svgData)));
  };

  return (
    <section
      data-testid="qrcode-section"
      className="py-16 md:py-24 px-6 md:px-12 bg-[#F5E6D3]/40"
    >
      <div className="max-w-4xl mx-auto" ref={ref}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7 }}
          className="flex flex-col items-center gap-6"
        >
          {/* QR Code */}
          <div className="bg-white p-6 rounded-sm shadow-md border border-[#D8D0C5]">
            <QRCodeSVG
              id="menu-qr-code"
              value={SITE_URL}
              size={220}
              level="H"
              fgColor="#2C2420"
              bgColor="#FDFBF7"
              data-testid="qr-code-svg"
            />
          </div>

          {/* Discreet download button */}
          <Button
            onClick={handleDownload}
            variant="ghost"
            className="text-xs uppercase tracking-[0.2em] text-[#8C847F] hover:text-[#C1624D] hover:bg-transparent
                       inline-flex items-center gap-2 h-auto py-2"
            style={{ fontFamily: "'Lato', sans-serif" }}
            data-testid="qr-download-btn"
          >
            <Download size={14} />
            Télécharger
          </Button>
        </motion.div>
      </div>
    </section>
  );
};
